import React from 'react';

import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useLocation, useNavigate } from "react-router-dom";

import SvgIcon from "../../CustomeComponents/SvgIcon";

const TableTabaList = ({ tabaData }) => {
	const tikDataList = tabaData;
	const titles = {
		"tohnit": "תכנית",
		"statusCodeText": "סטטוס",
		"taarihStatus": "תאריך סטטוס",
		"sugTohnit": "סוג תכנית"
	}

	const search = useLocation().search;
	const navigate = useNavigate();

	const LabeledDataItem = (label, value, dataItem, field) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			{
				dataItem !== undefined && field === "tohnit" ? 
					<div style={{ cursor: "pointer", color: "blue" }} onClick={() => openTiK(dataItem)}>
						{value}
					</div>
					: 
					<div className="value">{value}</div>
			}
		</div>
	}

	const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field], props.dataItem, props.field)}
		</td>
	}

	const openTiK = (tikDataItem) => {
		const systemCodeURL = new URLSearchParams(search).get("SystemCode");
		navigate(`/TabaDetails?TikNum=${tikDataItem.tohnit}&SystemCode=${systemCodeURL}&Page=TamztitTabalInfo`);
	}

	return (
		<Grid data={tikDataList} >
			<GridColumn field="tohnit" title={titles.tohnit} cell={LabeledCell} />
			<GridColumn field="statusCodeText" title={titles.statusCodeText} cell={LabeledCell} />
			<GridColumn field="taarihStatus" title={titles.taarihStatus} cell={LabeledCell} />
			<GridColumn field="sugTohnit" title={titles.sugTohnit} cell={LabeledCell} />
		</Grid>
    )
}

export default TableTabaList